var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"congr-state-print-map"}},[_c('div',[_c('MapTemplate',{attrs:{"showLayerPanel":false,"mapContainerId":_vm.mapContainerId,"loading":_vm.loading,"mapHeight":_vm.mapHeight}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }